import SpriteSymbol from "../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-copy",
  "use": "icon-copy-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-copy\">\n<path d=\"M1.33301 1.33334H9.99967V5H8.66634V2.66667H2.66634V8.66667H4.99967V10H1.33301V1.33334ZM5.99967 6H14.6663V14.6667H5.99967V6ZM7.33301 7.33334V13.3333H13.333V7.33334H7.33301Z\" fill=\"#6a6a6a\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol